import { LocalStorageManager } from "../components/localStorageDataManager";
import { CookieDataManager } from "../components/cookieDataManager";


export class StorageManager {
  public static isLocalStorageEnabled: boolean =
    LocalStorageManager.testIsStoreUsable();
  public static isCookieStorageEnabled: boolean =
    StorageManager.isLocalStorageEnabled == false
      ? CookieDataManager.testIsStoreUsable()
      : false;

  public static save<T>(key: string, dataT?: T, ttlInMinutes: number = 30) {
    if (this.isLocalStorageEnabled) {
      LocalStorageManager.save<T>(key, dataT, ttlInMinutes);
    } else {
      CookieDataManager.save<T>(key, dataT, ttlInMinutes);
    }
  }

  public static load<T>(key: string): T | undefined  {
    if (StorageManager.isLocalStorageEnabled) {
      return LocalStorageManager.load<T>(key);
    } else {
      return CookieDataManager.load<T>(key);
    }
  }

  
}
